import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./App.css";
import RouteComp from "./components/routes/route";
// import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ErrorBoundary from './components/Handler/ErrorBoundary';

// Global error handler for unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
  console.error('Promise:', event.promise);
  // Prevent the default behavior (which would log to console)
  event.preventDefault();
});

// Global error handler for uncaught errors
window.addEventListener('error', (event) => {
  console.error('Uncaught error:', event.error);
  console.error('Error details:', event.error?.message || event.error?.toString() || 'Unknown error');
});

function AppContent() {
  return (
    <ErrorBoundary>
      {/* <ToastContainer /> */}
      <RouteComp />
    </ErrorBoundary>
  );
}

function App() {
  return <AppContent />;
}

export default App;
